import { useQuery } from '@tanstack/react-query';

import { IWidgetCard } from '@entities/widget-card/model/types';
import { widgetShopApi } from '@entities/widget-shop/api';

export const useGetWidgetInfo = ({
    enabled = true,
    pickedWidgetId,
}: {
    enabled?: boolean;
    pickedWidgetId: IWidgetCard['id'] | null;
}) => {
    const { data, isSuccess, isPending, isFetching, isLoading, isFetched } = useQuery({
        ...widgetShopApi.getWidgetInfoQueryOptions({ widgetId: pickedWidgetId }),
        enabled,
    });

    return {
        data,
        isSuccess,
        isPending,
        isFetching,
        isLoading,
        isFetched,
    };
};
